module.exports = __webpack_public_path__ + "6e5600fb905694adbe5edcc0339c9e06.svg";